import React from 'react';

import { Container } from './SettingsBody.styles';

interface SettingsBodyProps {
  children: React.ReactNode;
  isEmptyState: boolean;
}

const SettingsBody: React.FC<SettingsBodyProps> = ({ children, isEmptyState }) => {
  return (
    // @ts-expect-error - styled-components v5 has incompatible types with React 18
    <Container data-cy="settings-body" isEmptyState={isEmptyState}>
      {children}
    </Container>
  );
};

export default SettingsBody;
